<template>
  <div class="main">
    <el-row class="line button">
<!--      <el-button @click="createShield" icon="el-icon-circle-plus-outline" type="primary">新增策略</el-button>-->
      <el-button icon="el-icon-circle-plus-outline"
                 size="small" @touchstart="createShield" @click="createShield">
        新增策略
      </el-button>
      <span style="margin-left: 20px;">
        主机：
        <el-select
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px;width: calc(100%/4 - 120px);"
          clearable
          filterable
          v-model="gatewaySn">
              <el-option
                :key="item.id"
                :label="item.name"
                :value="item.snCode"
                v-for="item in gatewayList">
              </el-option>
            </el-select>
      </span>
      <span style="margin-left: 20px;">
        空间：<el-cascader
        :options="spaceTree"
        @change="changeSpace"
        change-on-select="true"
        clearable
        collapse-tags
        filterable
        placeholder="请选择"
        size="mini"
        style="padding-bottom: 5px; width: calc(100%/4 - 120px)"
        v-model="spaceId">
        </el-cascader>
      </span>
      <span style="margin-left: 20px;">
        设备：<el-select
        filterable
        clearable
        @change="changeDevice"
        placeholder="可选择设备"
        size="mini"
        style="width: calc(100%/4 - 120px);"
        v-model="deviceId">
            <el-option
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-for="item in deviceList">
            </el-option>
          </el-select>
      </span>
      <span style="margin-left: 20px;">
        测点：<el-select
        filterable
        clearable
        placeholder="请选择测点"
        size="mini"
        style="width: calc(100%/4 - 120px);"
        v-model="pointId">
            <el-option
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-for="item in pointList">
            </el-option>
          </el-select>
      </span>
      <el-button size="mini"
                 style="float:right;font-weight:bold;padding:9px 25px;padding-right: 25px; color:rgba(7, 230, 248, 1)"
                 :loading="isSelect"
                 @touchstart.native="getDateInfo"
                 @click.native="getDateInfo"
                 >查询
      </el-button>
    </el-row>
    <el-table
      :data="tableData"
      border
      class="table"
      style="width: 100%;margin-top: 10px;">
      <el-table-column
        label="误告警类型"
        align="center"
        :formatter="statusFormat">
      </el-table-column>
      <!-- <el-table-column
        align="center"
        label="屏蔽时间段">
        <template slot-scope="scope">
          <span v-if="scope.row.alarmShieldTimeFrames.length > 0">
            <span :key="item.id" v-for="(item,index) in scope.row.alarmShieldTimeFrames">
              {{ item.startHour }}:{{ item.startMinute }}-{{ item.endHour }}:{{ item.endMinute }}
            <span v-if="index !== scope.row.alarmShieldTimeFrames.length-1">,</span>
            </span>
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column> -->
      <el-table-column
        label="所在空间"
        align="center"
        prop="spaceName">
      </el-table-column>
      <el-table-column
        :formatter="gatewayFormat"
        align="center"
        label="主机"
        prop="gatewayName">
      </el-table-column>
      <el-table-column
        :formatter="textFormat"
        align="center"
        label="设备名称"
        prop="deviceName">
      </el-table-column>
      <el-table-column
        :formatter="textFormat"
        align="center"
        label="测点"
        prop="pointName">
      </el-table-column>
      <el-table-column
        align="center"
        label="是否启用">
        <template slot-scope="scope">
          <el-switch
            @touchstart.native="shieldSwitch(scope.row)"
            @click.native="shieldSwitch(scope.row)"
            active-color="#13ce66"
            inactive-color="#ff4949"
            v-model="scope.row.isEnable">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="添加日期"
        prop="createTime">
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <div class="text-center control edit d-inline-block mr-1" @touchstart="handleEdit(scope.row)" @click="handleEdit(scope.row)">
            <img alt="编辑" class="d-inline-block" src="@/assets/images/icon/edit.png">
            编辑
          </div>
          <div class="text-center control delete d-inline-block ml-1" @touchstart="deleted(scope.row)" @click="deleted(scope.row)">
            <img alt="删除" src="@/assets/images/icon/delete.png">
            删除
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="margin-top: 15px;text-align: center;" v-if="tableData.length > 0">
      <el-pagination
        :current-page.sync="pageCurrent"
        :page-size.sync="pageSize"
        :total="dateTotal"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next">
      </el-pagination>
    </el-row>
    <function-dialog-component
      :closeClick="false"
      :dialog-title="title"
      :dialogVisible.sync="deviceDialogVisible"
      @dialogClose="(data) => this.deviceDialogVisible = data"
      center
      width="40vw">
      <div slot="content" style="padding: 10px 30px 20px 30px;">
        <AlarmMissModify :form="form" :spaceTree="spaceTree" @getById="getById" :id="selectId" ref="shield">
        </AlarmMissModify>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;">
        <el-button @touchstart="() => {this.deviceDialogVisible = false;this.form={};}" @click="() => {this.deviceDialogVisible = false;this.form={};}" size="mini">关 闭</el-button>
        <el-button @touchstart="preservation" @click="preservation" size="mini" type="primary">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import { getAlarmMissList, saveOrUpdate, getById, deleteById } from "@/network/alarm_miss";
import AlarmMissModify from "@/views/basic_operations/strategy/alarm_miss/comp/AlarmMissModify";
import {getSpaceTreeData, getTreeHaveDisabled} from '@/network/space-info';
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import lodash from "lodash";
import {gatewayList} from "@/network/device-gateway";
import {getBySpaceIdAndTypId} from "@/network/device-info";
import {listByDeviceId} from "@/network/device-measuring-point";

export default {
  name: "Shield",
  components: {FunctionDialogComponent, AlarmMissModify},
  data() {
    return {
      // 空间树
      spaceTree: [{
        value: '',
        label: ''
      }],
      gatewayList:[],
      deviceList:[],
      pointList:[],
      // 当前操作的策略id
      selectId: 0,
      pageSize: 10,
      pageCurrent: 1,
      dateTotal: 0,
      title: '新增误告警策略',
      // 当前空间id
      spaceInfoId: '',
      deviceDialogVisible: false,
      tableData: [],
      form: {},
      spaceId: null,
      gatewaySn: null,
      deviceId: null,
      pointId: null,
      isSelect:false
    }
  },
  created() {
    this.getSpaceTreeData();
    this.getDateInfo();
    // 获取主机列表
    this.gatewayData();
  },
  methods: {
    gatewayData(){
      gatewayList().then(res => {
        if (res.code === 0) {
          // 列表数据
          let bln = res.data == null;
          this.gatewayList = bln ? null : res.data;
        }
      })
    },
    //空间选择
    changeSpace() {
      this.getDeviceList();
    },
    //设备选择
    changeDevice(id) {
      this.getPointList(id)
    },
    getDeviceList(){
      this.deviceList = []
      this.pointList = []
      this.deviceId=null
      this.pointId=null
      this.getDevice(this.spaceId,0);
    },
    getDevice(spaceId, categoryId) {
      getBySpaceIdAndTypId(spaceId, categoryId).then(res => {
        if (res.code === 0) {
          this.deviceList = res.data;
        }
      })
    },
    //根据设备标识获取设备测点
    getPointList(deviceId) {
      this.pointList = []
      this.pointId = null
      this.getPoint(deviceId);
    },
    getPoint(deviceId) {
      listByDeviceId(deviceId).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            res.data.forEach(item => {
              this.pointList.push(item)
            })
          }
        }
      })
    },
    gatewayFormat(row) {
      return row.shieldType == 0 ? row.gatewayName : "--";
    },
    textFormat(row, column) {
      if (column.property == "pointName") {
        return row.pointName == undefined ? "--" : row.pointName;
      } else if (column.property == "deviceName") {
        return row.deviceName == undefined ? "--" : row.deviceName;
      }
    },
    shieldSwitch(row) {
      console.log(row);
      let switchLabel = row.isEnable ? '启用' : '停用';
      this.$confirm('是否确认' + switchLabel + "该告警屏蔽策略", {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            console.log('确认');
            // 执行保存
            saveOrUpdate([{id: row.id, isEnable: row.isEnable}]).then(res => {
              console.log(res);
              if (res.code === 0) {
                this.$message.success('操作成功');
              } else {
                row.isEnable = !row.isEnable;
                this.$message.error('操作失败');
              }
            });
          } else {
            row.isEnable = !row.isEnable;
          }
        }
      })
    },
    typeFormat(row) {
      let type = row.isEnable ? '是' : "否";
      return type;
    },
    statusFormat(row) {
      let type = row.misType == 1 ? "设备屏蔽" : "测点屏蔽";
      return type;
    },
    handleEdit(row) {
      this.title = '编辑告警屏蔽策略';
      this.selectId = row.id;
      this.form = lodash.cloneDeep(row);
      this.deviceDialogVisible = true;
    },
    deleted(row) {
      this.$confirm('是否确认删除该告警屏蔽策略', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            this.deleteById(row.id);
          }
        }
      })
    },
    refresh() {
      this.pageCurrent = 1;
      this.pageSize = 10;
      this.getDateInfo();
    },
    preservation() {
      let form = this.$refs.shield.getForm();
      console.log(form);
      if (form) {
        // 执行保存
        if (this.selectId <= 0) {
          saveOrUpdate(form).then(res => {
            if (res.code === 0) {
              this.form = {};
              this.$message.success('操作成功');
            } else {
              this.$message.error(res.message);
            }
            this.deviceDialogVisible = false;
            this.refresh();
          });
        } else {
          saveOrUpdate(form).then(res => {
            if (res.code === 0) {
              this.form = {};
              this.$message.success('操作成功');
            } else {
              this.$message.error(res.message);
            }
            this.deviceDialogVisible = false;
            this.refresh();
          });
        }
      }
    },
    getDateInfo() {
      getAlarmMissList(this.pageSize, this.pageCurrent,this.gatewaySn,this.spaceId,this.deviceId,this.pointId).then(res => {
        if (res.code === 0) {
          let bln = res.data == null ? true : false;
          this.tableData = bln ? null : res.data.records;
          // 总数
          this.dateTotal = bln ? 0 : res.data.total;
          this.pageSize = bln ? 1 : res.data.size;
          this.pageCurrent = bln ? 10 : res.data.current;
        }
      });
    },
    handleCurrentChange(val) {
      //当前为第几页时调用getData()显示第几页数据
      this.pageCurrent = val;
      this.pageSize = 10;
      this.getDateInfo();
    },
    createShield() {
      this.title = '新增告警屏蔽策略';
      this.selectId = 0;
      this.form = {};
      this.deviceDialogVisible = true;
    },
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          this.spaceTree = getTreeHaveDisabled(res.data);
          console.log(this.spaceTree)
        }
      });
    },
    getById(id) {
      getById({id: id}).then(res => {
        if (res.data) {
          return res.data;
        }
      });
    },
    deleteById(id) {
      deleteById({id: id}).then(res => {
        if (res.data) {
          if (res.code === 0) {
            this.form = {};
            this.$message.success('操作成功');
          } else {
            this.$message.error(res.message);
          }
          this.refresh();
        }
      });
    },
  }
}
</script>

<style scoped>
.main {
  padding: 15px 10px;
  overflow: auto;
}

/*分割线*/
.cross-line {
  width: 100%;
  margin-top: 10px;
  height: 0;
  /*border: 1px solid #299BFF;*/
  border-bottom: 1px solid rgba(41, 155, 255, 0.2);
  opacity: 0.5;
}

.table {
  margin-top: 20px;
}

.control img {
  margin-top: -5px;
}

.control.edit:hover {
  cursor: pointer;
  color: #299FFB;
}

.control.delete:hover {
  cursor: pointer;
  color: #fb2929;
}
</style>
